function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBillsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "8xcrjvb2da"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4560",
    style: {
      fill: "#3da2f8"
    },
    d: "M0 0h20v20H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#8xcrjvb2da)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.495 232.436a.59.59 0 0 0 .427-.179.574.574 0 0 0 .182-.424.621.621 0 0 0-.609-.609.574.574 0 0 0-.424.182.59.59 0 0 0-.179.427.61.61 0 0 0 .6.6zm0-3.061a.59.59 0 0 0 .427-.179.574.574 0 0 0 .182-.424.621.621 0 0 0-.609-.609.574.574 0 0 0-.424.182.59.59 0 0 0-.179.427.61.61 0 0 0 .6.6zm0-3.074a.59.59 0 0 0 .427-.179.574.574 0 0 0 .182-.424.621.621 0 0 0-.609-.609.574.574 0 0 0-.424.182.59.59 0 0 0-.179.427.61.61 0 0 0 .6.6zm2.423 6.144h4.566v-1.212h-4.566zm0-3.074h4.566v-1.211h-4.566zm0-3.061h4.566v-1.21h-4.566zm-4.706 9.234a1.232 1.232 0 0 1-1.212-1.211v-11.121a1.232 1.232 0 0 1 1.212-1.212h11.122a1.232 1.232 0 0 1 1.212 1.212v11.122a1.232 1.232 0 0 1-1.212 1.212zm0-1.212h11.122v-11.12h-11.122zm0-11.122z",
    transform: "translate(-123 -219.001)",
    style: {
      fill: "#3da2f8"
    },
    "data-name": "bills-icon"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillsIcon);
export default __webpack_public_path__ + "static/media/bills-icon.8eedfb2173e81b76783344333ee428f6.svg";
export { ForwardRef as ReactComponent };